/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown>, suffix: NonNullable<unknown> }} Explorer_Search_Results_CountInputs */



/**
* | output |
* | --- |
* | "Showing {shown} of {total} result{suffix}" |
*
* @param {Explorer_Search_Results_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_results_count = /** @type {((inputs: Explorer_Search_Results_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Results_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
	return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
});